module.exports = __webpack_public_path__ + "static/media/urbangoo25.4ce45979.webp";